import Axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'preloader',
    state: {
        preloader: false
    },
    getters: {
        preloader: state => {
            return state.preloader
        },
    },
    mutations: {
        SET_PRELOADER: (state, payload) => {
            state.preloader = payload
        },
    },
    actions: {
        PRELOADER(store, payload) {
            store.commit('SET_PRELOADER', payload)
        },
    }
}